export default __webpack_public_path__ + "static/media/Quiken_Suministros-07.82a933ff.svg";